<script>

	import Marquee from '../components/Marquee.svelte';

	/* text extends intro {
		...
		text: string
		size: string (s|m|l|xl|xxl|xxxl)
		position: string (top|center)
	} */

	export let text;
	export let size;
	export let position;

</script>

<div class="intro {position} text-{size}">
	<Marquee>
		{@html text}
	</Marquee>
</div>

<style>

	div {
		min-height: 50vh;
	}

	.center {
		padding: 4rem;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
	}

</style>